import { Client } from 'store/Client/Client.types';
import { createAsyncAction } from 'typesafe-actions';

export const getReachableClientsAsync = createAsyncAction(
  'REACHABLE_CLIENT | GET_REQ',
  'REACHABLE_CLIENT | GET_RES',
  'REACHABLE_CLIENT | GET_ERR',
)<void, Client.ReachableClientsResponse, string>();

export const asyncActions = {
  getReachableClientsAsync,
};
